if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.comboEnabled = this.dataset.combo === 'true'; 
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');
        this.initials =document.getElementById('textInput');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

     onSubmitHandler(evt) {
        evt.preventDefault();
       
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
      
        this.handleErrorMessage(); // Clear any previous error messages
      
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        const loadingSpinner = this.querySelector('.loading__spinner');
        if (loadingSpinner) loadingSpinner.classList.remove('hidden');
      
        // Validation: Check if personalization is selected and initials are filled
        const personalizationCheckbox = document.getElementById('showInput');
        const textInput1 = document.getElementById('textInput1');
        const textInput2 = document.getElementById('textInput2');
         const comboEnabled = document.getElementById('combo').value === "true";

       
          // if (textInput1.value.trim()) {
          //   this.handleErrorMessage('Please enter initials for the first input.');
          //   this.submitButton.classList.remove('loading');
          //   this.submitButton.removeAttribute('aria-disabled');
          //   this.querySelector('.loading__spinner').classList.add('hidden');
          //   return;
          // }

          if (comboEnabled && textInput1.value.trim() && !textInput2.value.trim()) {
            this.handleErrorMessage('Please enter initials for the second input.');
            this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
          }

        const config = fetchConfig('json');
      
        const productIdInput = this.form.querySelector('input[name="id"]');
        const linkedIdInput = this.form.querySelector('input[name="properties[_linked_id]"]');
           
        
        const initials1 = textInput1 ? textInput1.value : null;
        const initials2 = textInput2 ? textInput2.value : null;
        const uniqueId = Math.floor(Math.random() * 1000000000);

        // create an empty array to append all the items to be added to the cart
        const itemsToAdd = [];
    
          // if (linkedId) {
            
          //   itemsToAdd.push({
          //     id: productIdInput.value,
          //     quantity: 1,
          //     properties: {
          //       "Linked Id": uniqueId,
          //        "_unique_id": uniqueId
          //     }
          //   });
          // } else {
          //   itemsToAdd.push({
          //     id: productIdInput.value,
          //     quantity: 1
          //   });
          // }

       

       // Collect selected charms
        const charmCheckboxes = document.querySelectorAll('.free_gift_ul input[type="checkbox"]:checked');
        const charmItems = Array.from(charmCheckboxes).map(checkbox => ({
          id: checkbox.value,
          quantity: 1,
          properties: {
            "Free Charm": "Added",
            "Linked Id": uniqueId,
            "_unique_id": uniqueId,
          }
        }));

         // Add charm items to the array
        itemsToAdd.push(...charmItems);

        // Collect personalization item if selected
        console.log(this.form)
        if (textInput1 && textInput1.value.trim()) {

          const personalizationProperties = {
            "Linked Id": uniqueId,
            "_unique_id": uniqueId,
            "Initials 1": initials1
          };

          if (comboEnabled) {
            personalizationProperties["Initials 2"] = initials2;
          }
          
          itemsToAdd.push({
            id: 49096295743783, // Personalization product variant ID
            quantity: 1,
            properties: personalizationProperties
          });
        }

        // Collect selected add-ons
        document.querySelectorAll(".add-on-card.added").forEach((button) => {
          itemsToAdd.push({
            id: button.dataset.id,
            quantity: 1,
            properties: {
              "Category": "Add Ons"
            }
          });
        });


       if (itemsToAdd) {
            
            itemsToAdd.push({
              id: productIdInput.value,
              quantity: 1,
              properties: {
                "Linked Id": uniqueId,
                "_unique_id": uniqueId,
                "_main_item": 1
              }
            });
          } else {
            itemsToAdd.push({
              id: productIdInput.value,
              quantity: 1
            });
          }



        // Add main product to the cart
       // itemsToAdd.push({
       //        id: productIdInput.value,
       //        quantity: 1,
       //        properties: {
       //          "Linked Id": uniqueId,
       //           "_unique_id": uniqueId,
       //          "_main_item": 1
       //        }
       //      });


    
  console.log(itemsToAdd)

  let formData = {
    "items": itemsToAdd
  }

  if (this.cart) {
      formData['sections'] = this.cart.getSectionsToRender().map((section) => section.id)
      formData['sections_url'] = window.location.pathname;
      this.cart.setActiveElement(document.activeElement);
    }

  if (itemsToAdd.length === 0) {
    this.handleErrorMessage('Please select at least one item to add to the cart.');
    // resetSubmitButton.call(this);
    this.submitButton.classList.remove('loading');
            this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
            return;
  }
       
   config.body = JSON.stringify(formData);

  // Send a single request with all items
  console.log("Adding items to cart:", formData);
       console.log("*******************", this.cart);

  fetch(`${routes.cart_add_url}`, config)
  .then(response => response.json())
    .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: productIdInput.value,
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButton.querySelector('span').classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: productIdInput.value,
                cartData: response,
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    this.cart.renderContents(response);
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              this.cart.renderContents(response);
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      addPersonalisationToCart() {
        let someData = {
          'items': [{
            'id': 49096295743783, // Personalization product variant ID
            'quantity': 1
          }]
        };
      
        console.log("Adding personalization product");
      
        // Return the fetch promise to ensure it can be chained
        return fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json'
          },
          body: JSON.stringify(someData)
        })
        .then(response => {
          if (!response.ok) {
            throw new Error('Error adding personalization product');
          }
          return response.json();
        })
        .then(data => {
          console.log('Personalization product added:', data);
          return data;
        })
        .catch(error => {
          console.error('Error adding personalization product:', error);
          throw error; // Re-throw the error so it can be handled by the caller
        });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
